import { cn } from '@talentmesh/ui/lib/utils';
import DOMPurify from 'dompurify';
import formatSummary from './SummaryFormatting';

interface SimpleTextFormatterProps {
    value: string;
    className?: string;
}

const SimpleTextFormatter = ({ value, className }: SimpleTextFormatterProps) => {
    return (
        <div
            className={cn(
                'text-justify text-sm whitespace-pre-wrap [&>ul]:m-0 [&>ul]:list-disc [&>ul]:p-0 [&>ul>li]:ml-[2ch] [&>ul>li]:pl-[2ch]',
                className,
            )}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(formatSummary(value)) }}
        />
    );
};

export default SimpleTextFormatter;
